import React, { useState, useEffect, useRef } from 'react';
import { ModalUsageProps } from './Modal'
import { WorkspaceData } from './GraphData'
import { SearchBar } from './SearchBar'
import { SettingsBar } from './SettingsBar'
import { WorkspaceBar } from './WorkspaceBar'

interface HeaderProps {
  modalUsageProps : ModalUsageProps
  workspaces : WorkspaceData[] 
  fetchWorkspaces: Function
  workspaceParam : string
  selectOptions : Set<string>
  selectedFilterOption : string
  setSelectedFilterOption : Function
  helpModal : Function
  tokenModal: Function
  importModal : Function
  exportModal : Function
}

export const Header : React.FC<HeaderProps> = (
  {
    modalUsageProps,
    workspaces,
    fetchWorkspaces,
    workspaceParam,
    selectOptions, 
    selectedFilterOption, 
    setSelectedFilterOption, 
    helpModal,
    tokenModal,
    importModal,
    exportModal,
  }) => {

  return (
    <div className="header">
      <SearchBar selectOptions={selectOptions} selectedFilterOption={selectedFilterOption} setSelectedFilterOption={setSelectedFilterOption}/>
      <div className="header-main-bar">
        <WorkspaceBar modalUsageProps={modalUsageProps} workspaces={workspaces} fetchWorkspaces={fetchWorkspaces} workspaceParam={workspaceParam}/>
      </div>
      <SettingsBar tokenModal={tokenModal} helpModal={helpModal} importModal={importModal} exportModal={exportModal}/>
    </div>
  )
}
